export default [
  'club_name',
  'status',
  { key: 'user', label: 'Owner', sorter: false },
  { key: 'action', label: '' }
]
